import React from 'react';
import EMSALogo from '../../images/emsa-logo-updated.png';

/**
 * @summary Generates a site header with the EMSA logo.
 * @see https://github.com/Office-of-Digital-Services/California-State-Web-Template-react/wiki/Structure#siteheader
 * 
 * @example
 * <SiteHeader />
 * 
 * @returns {React.ReactElement} Returns the SiteHeader structure element.
 */

const SiteHeader = () => (
  <div className="section-default">
    <div className="branding">
      <div className="header-organization-banner">
        <a href="/">
          <div className="logo-assets">
            <img src={EMSALogo} className="logo-img" alt="EMSA Logo" />
            {/* Text removed as requested */}
          </div>
        </a>
      </div>
    </div>
  </div>
)

export default SiteHeader